import { ENDPOINTS } from '../_config';

// #RP - Task 92 - Bind data to Policies Form in Front-End.
export const getPoliciesPageData = async () => {
  try {
    const request = await fetch(ENDPOINTS.GET_POLICIES);
    if (request.status === 204) {
      // 204 => No content in backend
      return request;
    }
    return await request.json();
  } catch (e) {
    return null;
  }
};
